import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getMedia(id) {
        const response = await axios.get(API_URL + "/medias/" + id, {headers: authHeader()});
        return response.data;
    },

    async deleteMedia(id) {
        await axios.delete(API_URL + "/medias/delete/" + id, {headers: authHeader()});
    },

    async downloadMedia(id) {
        const response = await axios.get(API_URL + "/medias/download/" + id, { headers: authHeader(), responseType: 'blob'});
        const filename = `downloaded_file.${response.data.type.split('/')[1] || 'bin'}`;
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    },
}




